<div class="container my-4" *ngIf="!loading">
    <div class="headerBar col-md-6 offset-md-3 py-4 pr-0">
        <div class="d-flex justify-content-end align-items-center">
            <button type="button" *ngIf="!editing; else editingBlock" class="btn btn-text-gray btn-icon align-self-center" (click)="editing=true">
                <svg><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
                <span cvLocalizedText langSection="Common" langKey="Edit">Edit</span>
            </button>
            <ng-template #editingBlock>
                <button type="button" class="btn btn-secondary" (click)="cancel()" cvLocalizedText langSection="Company_Settings" langKey="Cancel">Cancel</button>
                <button type="button" class="btn btn-primary ml-2" (click)="save()" [disabled]="saving || !hasChange" cvLocalizedText [langSection]="'Company_Settings'" [langKey]="'Save'">Save</button>
            </ng-template>
        </div>
    </div>
    <div class="col-md-6 offset-md-3 content p-4">
        <div *ngFor="let group of fieldGroups">
            <ng-container *ngIf="getFieldGroup(group.GroupName).length > 0">
                <div class="subtitle-1 font-weight-bold">{{group.DisplayName}}</div>
                <div class="row my-3" *ngFor="let field of getFieldGroup(group.GroupName)">
                    <div class="col-5 align-self-center">
                        <span [matTooltip]="getTooltip(field.FieldName)">{{field.DisplayName}}</span>
                    </div>

                    <ng-container [ngSwitch]="field.FieldName">
                        <ng-container *ngSwitchCase="'CultureName'">
                            <div class="col">
                                <select class="form-control" style="width: 148px;" [disabled]="!editing" [(ngModel)]="field.TextValue" (ngModelChange)="onChange();">
                                    <option *ngFor="let option of field.Options" [value]="option.TextValue">{{option.DisplayValue}}</option>
                                </select>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'WeekStartDay'">
                            <div class="col">
                                <select class="form-control" style="width: 148px;" [disabled]="!editing" [(ngModel)]="field.TextValue" (ngModelChange)="onChange();">
                                    <option *ngFor="let option of field.Options" [value]="option.TextValue">{{option.DisplayValue}}</option>
                                </select>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Priority_For_User_Identifier'">
                            <div class="col">
                                <select class="form-control form-control-select" [disabled]="!editing" [(ngModel)]="field.TextValue" (ngModelChange)="onChange();">
                                    <option *ngFor="let option of field.Options" [value]="option.TextValue">{{option.DisplayValue}}</option>
                                </select>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'CoinToCurrencyValue'">
                            <div class="col d-flex align-items-center">
                                <div class="input-group" style="max-width: 148px;">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text px-2 py-0 g-icon g-icon-coin"></span>
                                    </div>
                                    <input class="form-control form-control-lg" type="number" maxlength="6" min="0" step="any" placeholder="Coins" aria-invalid="false" [disabled]="!editing" [(ngModel)]="field.NumericValue" (ngModelChange)="onChange();" oninput="validity.valid || (value = '1');">
                                </div>
                                <span class="ml-2" cvLocalizedText [langSection]="'Company_Settings'" [langKey]="'Per_Dollar'">per US Dollar</span>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <div class="col">
                                <input class="form-control form-control-lg" type="number" *ngIf="field.FieldType == 0" [disabled]="!editing" [(ngModel)]="field.NumericValue" (ngModelChange)="onChange()">
                                <input class="form-control form-control-lg" type="text" *ngIf="field.FieldType == 1" [disabled]="!editing" [(ngModel)]="field.TextValue" (ngModelChange)="onChange()">
                                <input class="form-check-input ml-0" type="checkbox" *ngIf="field.FieldType == 2" [disabled]="!editing" [ngModel]="field.NumericValue" (ngModelChange)="$event == true ? field.NumericValue = 1 : field.NumericValue = 0; onChange();">
                                <select class="form-control" style="width: 148px;" *ngIf="field.FieldType == 3" [disabled]="!editing" [(ngModel)]="field.NumericValue" (ngModelChange)="onChange();">
                                    <option *ngFor="let option of field.Options" [value]="option.NumericValue">{{option.DisplayValue}}</option>
                                </select>
                                <input class="form-check-input ml-0" type="file" *ngIf="field.FieldType == 4" [disabled]="!editing" [(ngModel)]="field.TextValue" (ngModelChange)="onChange()">
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </div>

        <cv-company-edit-sso [(ssoObject)]="ssoSettingsValues" (ssoObjectChange)="onChange()" (validationErrors)="ssoErrors = $event" [editing]="editing"></cv-company-edit-sso>
    </div>
</div>
